import { FC, PropsWithChildren } from 'react';
import { PropsWithClassName } from '@/types/PropsWithClassName';
import { cn } from '@/utils/classNames.ts';
import { CircularProgress } from '@mui/material';

type LoaderProps = {
  isLoading: boolean;
  hideBg?: boolean;
};

const LoaderOverlay: FC<PropsWithClassName<PropsWithChildren<LoaderProps>>> = ({
  className,
  isLoading = false,
  children,
  hideBg = false,
}) => {
  return (
    <div className={cn('relative min-h-10', className)}>
      {isLoading && (
        <div
          className={cn('absolute w-full h-full z-10 flex justify-center items-center cursor-wait', {
            'bg-primary-400 bg-opacity-5': !hideBg,
          })}
        >
          <CircularProgress />
        </div>
      )}
      {children}
    </div>
  );
};

export default LoaderOverlay;
